import { TripState } from "../../../types/types";
import {
  GET_FLEET_TRIP,
  GET_FLEET_TRIP_SUCCESS,
  GET_FLEET_TRIP_FAILURE,
  GET_DEVICE_USER_MAPPING,
  GET_DEVICE_USER_MAPPING_FAILURE,
  GET_DEVICE_USER_MAPPING_SUCCESS,
  GET_DEVICE_USERS,
  GET_DEVICE_USERS_SUCCESS,
  GET_DEVICE_USERS_FAILURE,
  STORE_STOMP_CLIENT,
} from "./actionTypes";

const tripState: TripState = {
  tripDetails: {
    loading: false,
    data: null,
  },
  deviceUserMapping: {
    loading: false,
    data: null,
  },
  deviceUsers: {
    loading: false,
    data: null,
  },
  stompClient: {
    ref: null
  }
};

export default (state = tripState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case GET_FLEET_TRIP:
      return {
        ...state,
        tripDetails: {
          loading: true,
          data: null,
        },
      };

    case GET_FLEET_TRIP_SUCCESS:
      return {
        ...state,
        tripDetails: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_FLEET_TRIP_FAILURE:
      return {
        ...state,
        tripDetails: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_DEVICE_USER_MAPPING:
      return {
        ...state,
        deviceUserMapping: {
          loading: true,
          data: null,
        },
      };

    case GET_DEVICE_USER_MAPPING_SUCCESS:
      return {
        ...state,
        deviceUserMapping: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_DEVICE_USER_MAPPING_FAILURE:
      return {
        ...state,
        deviceUserMapping: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_DEVICE_USERS:
      return {
        ...state,
        deviceUsers: {
          loading: true,
          data: null,
        },
      };

    case GET_DEVICE_USERS_SUCCESS:
      return {
        ...state,
        deviceUsers: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_DEVICE_USERS_FAILURE:
      return {
        ...state,
        deviceUsers: {
          loading: false,
          data: action.payload,
        },
      };

    case STORE_STOMP_CLIENT:
      return {
        ...state,
        stompClient: {
          ref: action.payload
        }
      } 
      
    default:
      return {
        ...state,
      };
  }
};
